// extracted by mini-css-extract-plugin
export default {"login":"LoginPage_login__DMTJ2"};